import { Route, Routes } from 'react-router-dom';
import KioskSelectionScreen from 'modules/kiosk/KioskSelectionScreen';

/**
 * While the kiosk is active, every route renders the selection screen. The catch-all means deep links,
 * direct URLs and browser back/forward can't reach any non-kiosk screen.
 */
const KioskRouter = () => (
  <Routes>
    <Route path="*" element={<KioskSelectionScreen />} />
  </Routes>
);

export default KioskRouter;
